// src/store/AuthContext.tsx
import React, { createContext } from 'react';
import { UserLoginDTO } from '../../Models/Login';

interface AuthContextType {
    isLoggedIn: boolean;
    token: string | null;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    isPatient?: boolean;
    roles?: string[];
    userId: number | null;
    siteId?: string | null;
    registrationAccountType?: 'patient' | 'manager' | null;
    setRegistrationAccountType?: (t: 'patient' | 'manager' | null) => void;
    login: (loginData: UserLoginDTO) => Promise<boolean>;
    logout: () => void;
    isTokenExpired: (token:string) => boolean;
}

const AuthContext = createContext<AuthContextType>({
    isLoggedIn: false,
    token: null,
    isAdmin: false,
    isSuperAdmin: false,
    isPatient: false,
    roles: [],
    userId: null,
    registrationAccountType: null,
    setRegistrationAccountType: () => {},
    login: async () => false,
    logout: () => { },
    isTokenExpired:() => false
    
});

export default AuthContext;